<template>
  <div id="container" :type="glb.pageType">
    <div class="page-schools">
      <mvtHeader :geoInfo="geo"/>
      <schoolsBase v-if="schoolsData.pageType==='vschools_base'" :data="schoolsData" />
      <schoolsState v-else-if="schoolsData.pageType==='vschools_state'" :data="schoolsData" />
      <template v-else>
        <staticWelcomeSearch v-if="schoolsData.pageType==='vschools_city'" :imageUrl="schoolSrc" :title="schoolsData.title"/>
        <schoolsWelcome :data="schoolsData" v-else/>
        <div class="bg-white bar">
          <mvtShifter type="2">
            <div v-if="urlsInfo.listings.show"><a :href="urlsInfo.listings.url">Listings</a></div>
            <div v-if="urlsInfo.markettrends.show"><a :href="urlsInfo.markettrends.url">Market Trends</a></div>
            <div v-if="urlsInfo.schools.show" class="active"><a :href="urlsInfo.schools.url">Schools</a></div>
          </mvtShifter>
        </div>
        <schoolsCity v-if="schoolsData.pageType==='vschools_city'" :data="schoolsData" />
        <schoolsDistrict v-else-if="schoolsData.pageType==='vschools_district'" :data="schoolsData" />
        <schoolsNeighbourhood v-else-if="schoolsData.pageType==='vschools_neighbourhood'" :data="schoolsData" />
        <schoolsZipcode v-else-if="schoolsData.pageType==='vschools_zipcode'" :data="schoolsData" />
        <schoolsDistrictState v-else-if="schoolsData.pageType==='vschools_districtstate'" :data="schoolsData" />
      </template>
      <mvtFooter :geoInfo="geo"/>
      <mvtDialogCenter></mvtDialogCenter>
    </div>
  </div>
</template>

<script src="./page-schools.js"></script>